import styled from 'styled-components';


export const Div = styled.div.attrs({
    className: 'hero-bg-animation',
})`
    width:600px;
    height: 500px;
`
